import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';


const CirculoStatus = (props) => {
    const circleColor =
        props.status === "Pendente"
            ? "blue"
            : props.status === "Aprovado"
                ? "green"
                : props.status === "Suspeito"
                    ? "red"
                    : props.status === "Desativado"
                        ? "gray"
                        : props.status === "Indefinido"
                            ? "purple"
                            : props.status === "Reanalise"
                                ? "orange"
                                : props.status === "Inconsistente"
                                    ? "yellow"
                                    : props.status === "Erro"
                                        ? "black"
                                        : props.status === "white";
    const useStyles = makeStyles((theme) => ({
        boxData: {
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
        },
        circle: {
            background: circleColor,
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            border: "1px solid black",
            textAlign: "center",
            lineHeight: "20px",
        },
    }));

    const classes = useStyles();

    return (
        <Fragment>
            <div className={classes.boxData}>
                <Tooltip title={props.status}>
                    <div className={classes.circle}></div>
                </Tooltip>
            </div>
        </Fragment>
    );
};

const CirculoVeredito = (props) => {
    const useStyles = makeStyles((theme) => ({
        boxData: {
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
        },
        circle: {
            background: props.verId === "0" ? "green" : "red",
            width: "20px",
            height: "20px",
            color: "white",
            borderRadius: "50%",
            border: "1px solid black",
            textAlign: "center",
            lineHeight: "20px",
        },
        text: {
            background: "transparent",
            color: "blue",
            fontSize: "xx-small",
        },
    }));

    const classes = useStyles();

    //console.log(props.veredito, typeof (props.veredito))
    if (props.analise) {
        let ver = "X";
        if (props.analise === "Cheio") {
            ver = "C";
        } else if (props.analise === "Vazio") {
            ver = "V";
        }
        return (
            <Fragment>
                <div className={classes.boxData}>
                    <div className={classes.circle}>{ver}</div>
                </div>
            </Fragment>
        );
    } else {
        return <></>;
    }
};



const CirculoVereditoIa = (props) => {
    const useStyles = makeStyles((theme) => ({
        boxData: {
            display: "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
        },
        circle: {
            background: props.veredito.split(",")[1] === "0" ? "green" : "red",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            border: "1px solid black",
            textAlign: "center",
            lineHeight: "20px",
        },
        text: {
            background: "transparent",
            color: "blue",
            fontSize: "xx-small",
            textAlign: "center",
            lineHeight: "20px",
        },
    }));

    const classes = useStyles();

    if (props.veredito !== ",") {
        const vereditos = props.veredito.split(",");
        let ver = "";
        if (vereditos[0] === "Cheio") {
            ver = "C";
        } else {
            ver = "V";
        }
        //        console.log(props.veredito);
        if (vereditos[0] === "Vazio" && vereditos[1] === "0") {
            //        console.log(props.veredito);
            return (
                <Fragment>
                    <div className={classes.boxData}>
                        <div className={classes.circle}>{ver}</div>
                        <div className={classes.text}>Veredito (IA)</div>
                    </div>
                </Fragment>
            );
        } else {
            return <div></div>;
        }
    } else {
        return <div></div>;
    }
};

const CirculoVereditoPorto = (props) => {
    if (props.veredito) {
        const circuloCor =
            props.veredito === "0" ? "green" : props.veredito === "1" ? "red" : "white";
        const useStyles = makeStyles((theme) => ({
            boxData: {
                display: "flex",
                "flex-direction": "column",
                "justify-content": "center",
                "align-items": "center",
            },
            circle: {
                background: circuloCor,
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                textAlign: "center",
                lineHeight: "20px",
            },
            text: {
                background: "transparent",
                color: "blue",
                fontSize: "xx-small",
                textAlign: "center",
                lineHeight: "20px",
            },
        }));

        const classes = useStyles();
        return (
            <Fragment>
                <div className={classes.boxData}>
                    <div className={classes.circle}></div>
                </div>
            </Fragment>
        );
    } else {
        return <></>;

    }
};

const CirculoDoisVeredito = (props) => {
    const useStyles = makeStyles((theme) => ({
        box: {
            "padding-top": "25%",
            "padding-bottom": "15%",
        },
        boxData: {
            display: "flex",
            "flex-direction": "row",
            "justify-content": "center",
            "align-items": "center",
        },
        circle1: {
            background: props.veredito1.split(":")[1] === "0" ? "green" : "red",
            width: "20px",
            height: "20px",
            marginLeft: "1px",
            marginRight: "1px",
            borderRadius: "50%",
            textAlign: "center",
            lineHeight: "20px",
        },
        circle2: {
            background: props.veredito2.split(":")[1] === "0" ? "green" : "red",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            marginLeft: "1px",
            marginRight: "1px",
            textAlign: "center",
            lineHeight: "20px",
        },
        text: {
            background: "transparent",
            color: "blue",
            fontSize: "xx-small",
        },
    }));

    const classes = useStyles();

    if (props.veredito !== null) {
        const vereditos1 = props.veredito1.split(":");
        let ver1 = "";
        if (vereditos1[0] === "Cheio") {
            ver1 = "C";
        } else {
            ver1 = "V";
        }

        const vereditos2 = props.veredito2.split(":");
        let ver2 = "";
        if (vereditos2[0] === "Cheio") {
            ver2 = "C";
        } else {
            ver2 = "V";
        }
        console.log("Veredito1", props.veredito1, "Veredito2", props.veredito2);
        return (
            <Fragment>
                <div className={classes.box}>
                    <div className={classes.boxData}>
                        <div className={classes.circle1}>{ver1}</div>
                        {props.veredito2 === ":" ? (
                            <div></div>
                        ) : (
                            <div className={classes.circle2}>{ver2}</div>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    } else {
        return <div></div>;
    }
};

export {
    CirculoStatus,
    CirculoVeredito,
    CirculoVereditoIa,
    CirculoDoisVeredito,
    CirculoVereditoPorto,
};
